function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { P, withDefaultMedia } from "../";
const mobile = {
  margin: 16,
  gutter: 16,
  columns: 70
};
const tablet = {
  margin: 32,
  gutter: 16,
  columns: 74
};
const desktop = {
  margin: 40,
  gutter: 24,
  columns: 80
};

const GridInternal = ({
  children,
  columns = 0,
  columnLeft = 0,
  columnRight = 0,
  matches,
  ...props
}) => {
  const calc = (a, b, c) => {
    return a * b + (a - 1) * c;
  };

  const calc2 = (a, b, c) => {
    return a * b + (a + 1) * c;
  };

  const columnsCalc = itemCount => {
    const calcMobile = calc(itemCount, mobile.columns, mobile.gutter);
    const calcTablet = calc(itemCount, tablet.columns, tablet.gutter);
    const calcDesktop = calc(itemCount, desktop.columns, desktop.gutter);
    return matches.small ? calcMobile : matches.medium ? calcTablet : calcDesktop;
  };

  const columnSpacing = itemCount => {
    const calcMobile = calc(itemCount, mobile.columns, mobile.gutter);
    const calcDesktop = calc2(itemCount, desktop.columns, desktop.gutter);
    return matches.small ? calcMobile : calcDesktop;
  };

  return /*#__PURE__*/React.createElement(MainColumnStyle, _extends({
    left: columnLeft !== 0 ? columnSpacing(columnLeft) : undefined,
    right: columnRight !== 0 ? columnSpacing(columnRight) : undefined,
    calcWidth: columns === 0 ? columns : columnsCalc(columns)
  }, props), children);
};

export const Grid = withDefaultMedia(GridInternal);
const MainColumnStyle = styled(P).attrs({
  as: "div"
})`
  box-sizing: border-box;
  display: flex;
  ${props => props.column && "flex-direction: column;"};
  ${props => props.row && "flex-direction: row;"};
  ${props => props.stretch && "flex-grow: 1;"};
  ${props => props.noShrink && "flex-shrink: 0;"};
  ${props => props.left && `margin-left: ${props.left}px;`};
  ${props => props.right && `margin-right: ${props.right}px;`};

  @media only screen and ${props => props.theme.media.small} {
    ${props => props.calcWidth !== 0 && `min-width: ${props.calcWidth}px;`};
  }
  @media only screen and ${props => props.theme.media.medium} {
    ${props => props.calcWidth !== 0 && `min-width: ${props.calcWidth}px`};
  }
  @media only screen and ${props => props.theme.media.large} {
    ${props => props.calcWidth !== 0 && `width: ${props.calcWidth}px`};
  }
`;
export const GridColumn = styled(Grid)`
  align-items: ${props => props.xStart ? "flex-start" : props.xCenter ? "center" : props.xEnd ? "flex-end" : "stretch"};
  flex-direction: column;
  justify-content: ${props => props.yCenter ? "center" : props.yEnd ? "flex-end" : "flex-start"};
`;
export const GridRow = styled(Grid)`
  align-items: ${props => props.yStart ? "flex-start" : props.yCenter ? "center" : props.yEnd ? "flex-end" : "stretch"};
  flex-direction: row;
  justify-content: ${props => props.xCenter ? "center" : props.xEnd ? "flex-end" : "flex-start"};
`;
export const GridCell = styled(GridRow)`
  align-items: center;
  box-sizing: content-box;
  font-size: 15px;
  ${props => props.header && "font-weight: 600;"};

  @media only screen and ${props => props.theme.media.small} {
    & + & {
      padding-left: 16px;
    }
  }
  @media only screen and ${props => props.theme.media.medium} {
    padding-left: 8px;
    padding-right: 8px;
  }
  @media only screen and ${props => props.theme.media.large} {
    padding-left: 12px;
    padding-right: 12px;
  }
`;